import { useTranslation } from 'react-i18next';

export default function ChatbotInput({ inputValue, setInputValue, onSend, isLoading, disabled, placeholder }) {
  const { t } = useTranslation();
  const handleKey = (e) => { if (e.key === 'Enter') onSend(); };

  return (
    <div className="border-t p-4 bg-white">
      <div className="flex space-x-2">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKey}
          placeholder={placeholder}
          disabled={disabled || isLoading}
          className="flex-1 px-4 py-2.5 border rounded-xl focus:ring-2 focus:ring-blue-500 text-sm"
        />
        <button
          onClick={onSend}
          disabled={disabled || isLoading}
          className="bg-blue-600 text-white px-5 py-2.5 rounded-xl hover:bg-blue-700 disabled:opacity-50"
        >
          {t('chatbot.input.send')}
        </button>
      </div>
    </div>
  );
}